import * as React from "react";

function SvgHasOffers(props, ref) {
  return (
    <svg
      id="HasOffers_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 398 154"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {
          ".HasOffers_svg__st0{fill:#005aff}.HasOffers_svg__st1{fill:#313131}.HasOffers_svg__st2{fill:#414141}.HasOffers_svg__st3{font-family:&apos;HelveticaNeue-Light&apos;}.HasOffers_svg__st4{font-size:77.5484px}.HasOffers_svg__st6{fill:#fff}"
        }
      </style>
      <path
        id="HasOffers_svg__XMLID_47_"
        className="HasOffers_svg__st0"
        d="M274.2 134.3c-.9 0-2.3.3-3.4 1.1v-5.3c0-.3-.3-.6-.6-.6h-3c-.3 0-.6.3-.6.6v17.1c0 .3.3.6.6.6h2.8c.3 0 .5-.2.6-.5v-.3c.9.7 2 1.1 3.5 1.1 4.1 0 6.8-2.8 6.8-6.9-.1-4.2-2.6-6.9-6.7-6.9zm-.3 3.9c1.7 0 2.9 1.2 2.9 3s-1.2 3-2.9 3c-1.4 0-3-1-3-3 0-1.7 1.4-3 3-3z"
      />
      <path
        id="HasOffers_svg__XMLID_20_"
        className="HasOffers_svg__st0"
        d="M296.6 134.8c-.1-.2-.3-.3-.5-.3h-3.3c-.2 0-.4.1-.5.3l-2.2 5.3-.7 1.8-2.4-7.1c-.1-.2-.3-.4-.5-.4H283c-.2 0-.4.1-.5.2-.1.2-.1.4-.1.5l4.7 11.6-2.1 5c-.1.2-.1.4 0 .5.1.1.3.3.5.3h3.3c.2 0 .4-.1.5-.3l7.3-17.1c.1.2.1 0 0-.3z"
      />
      <path
        id="HasOffers_svg__XMLID_19_"
        className="HasOffers_svg__st0"
        d="M393.3.7H141.4c-1.7 0-3 .8-3 2.6v105.8c0 1.7 1.3 2.9 3 2.9h34.7c1.7 0 3.2 1.5 3.2 3.3v30c0 2.7 3.1 4.1 5 2.3l40-34.7c.5-.5 1.2-.8 1.9-.8h167.1c1.7 0 3.4-1.2 3.4-2.9V3.3c0-1.7-1.7-2.6-3.4-2.6z"
      />
      <path
        id="HasOffers_svg__XMLID_18_"
        className="HasOffers_svg__st1"
        d="M.7 31.4h8.2v19.5c3.1-3.5 5.8-6.4 11.4-6.4 8.2 0 13.1 5.5 13.1 14v23h-8.2V61c0-5.6-3-8.9-8-8.9-4.8 0-8.4 3.4-8.4 9v20.3H.7v-50z"
      />
      <path
        id="HasOffers_svg__XMLID_41_"
        className="HasOffers_svg__st1"
        d="M66 81.4v-4.3c-3.1 3-6.1 5.2-11.6 5.2-6.9.1-12.9-3.9-12.9-11.1v-.1c0-8.1 6.1-11.9 14.6-11.9 4.4 0 6.8.6 9.9 1.5V60c0-5-3.2-7.8-9-7.8-4.1 0-7.1.9-10.4 2.2l-2.2-6.7c4-1.8 8-3.1 13.9-3.1 10.7 0 15.9 5.7 15.9 15.4v21.3H66zm0-15c-2-.8-4.9-1.4-8.2-1.4-5.2 0-8.2 2.1-8.2 5.6v.1c0 3.5 3 5.4 6.8 5.4 5.5 0 9.5-3.1 9.5-7.7v-2z"
      />
      <path
        id="HasOffers_svg__XMLID_15_"
        className="HasOffers_svg__st1"
        d="M81.1 76.9l3.7-5.6c3.9 3 8.4 4.5 12 4.5 3.6 0 5.8-1.5 5.8-3.9v-.1c0-2.9-3.8-3.8-8.1-5.1-5.3-1.7-11.2-3.9-11.2-10.8v-.1c0-6.9 5.5-11.1 12.8-11.1 4.6 0 9.4 1.6 13.3 4.2l-3.4 5.9c-3.5-2.1-7.3-3.5-10.3-3.5-3.3 0-5.2 1.5-5.2 3.7 0 2.7 3.9 3.7 8.2 5.1 5.3 1.6 11.2 4.1 11.2 10.6v.1c0 7.7-5.8 11.4-13.4 11.4-5.2.1-10.8-1.7-15.4-5.3z"
      />
      <text
        id="HasOffers_svg__XMLID_14_"
        transform="translate(126.212 83.681)"
        className="HasOffers_svg__st2 HasOffers_svg__st3 HasOffers_svg__st4"
        letterSpacing={1}
      />
      <text
        id="HasOffers_svg__XMLID_13_"
        transform="translate(149.687 83.681)"
        className="HasOffers_svg__st2 HasOffers_svg__st3 HasOffers_svg__st4"
      />
      <path
        id="HasOffers_svg__XMLID_35_"
        className="HasOffers_svg__st6"
        d="M170.1 62.1V62c0-10.4 8.3-19 19.4-19 11.1 0 19.4 8.5 19.4 18.9v.1c0 10.3-8.3 19-19.5 19-11.1-.1-19.3-8.6-19.3-18.9zm30.6 0V62c0-6.4-4.8-11.7-11.3-11.7-6.6 0-11.1 5.2-11.1 11.5v.2c0 6.3 4.8 11.7 11.2 11.7 6.7-.1 11.2-5.4 11.2-11.6z"
      />
      <path
        id="HasOffers_svg__XMLID_10_"
        className="HasOffers_svg__st6"
        d="M219.1 50.8H215v-7.1h4.1v-2.3c0-4.1 1.1-7.1 3.1-9 1.9-1.9 4.8-2.9 8.4-2.9 2.9 0 4.9.4 6.9.9v7c-2-.5-3.4-.9-5.1-.9-3.2 0-5.1 1.7-5.1 5.5v1.6h10.2v7.1h-10.2v29.6h-8.2V50.8z"
      />
      <path
        id="HasOffers_svg__XMLID_9_"
        className="HasOffers_svg__st6"
        d="M245.6 50.8h-5.1v-7.1h5.1v-2.3c0-4.1.8-7.1 2.8-9 1.9-1.9 4.5-2.9 8.1-2.9 2.9 0 4.6.4 6.6.9v7c-2-.5-2.9-.9-4.6-.9-3.2 0-4.6 1.7-4.6 5.5v1.6h9.2v7.1h-9.2v29.6h-8.2V50.8h-.1z"
      />
      <path
        id="HasOffers_svg__XMLID_30_"
        className="HasOffers_svg__st6"
        d="M267 62v-.1c0-10.4 7.5-19 17.9-19 11.5 0 17.5 9.2 17.5 19.7 0 .7 0 1.4-.1 2.4h-26.7c.9 6.1 5.1 9.1 10.5 9.1 4.1 0 6.9-1.5 9.9-4.4l4.9 4.3c-3.5 4.2-8.3 6.8-14.9 6.8-10.8.1-19-7.6-19-18.8zm27.1-3.1c-.5-5.1-3.7-9.6-9.2-9.6-5.1 0-8.7 4.5-9.4 9.6h18.6z"
      />
      <path
        id="HasOffers_svg__XMLID_6_"
        className="HasOffers_svg__st6"
        d="M310.9 43.6h8.2v8.3c2-5.4 6.1-9.2 13.3-8.9v8.8h-.8c-7.3 0-12.5 4.8-12.5 14.4v14.2h-8.2V43.6z"
      />
      <path
        id="HasOffers_svg__XMLID_5_"
        className="HasOffers_svg__st6"
        d="M336.2 75.3l3.7-5.6c3.9 3 8.4 4.5 12 4.5 3.6 0 5.8-1.5 5.8-3.9v-.1c0-2.9-3.8-3.8-8.1-5.1-5.4-1.5-11.3-3.7-11.3-10.7v-.1c0-6.9 5.5-11.1 12.8-11.1 4.6 0 9.4 1.6 13.3 4.2l-3.4 5.9c-3.5-2.1-7.2-3.5-10.3-3.5-3.3 0-5.2 1.5-5.2 3.7v.1c0 2.7 3.9 3.7 8.2 5.1 5.3 1.6 11.2 4.1 11.2 10.6v.1c0 7.7-5.8 11.4-13.4 11.4-5 0-10.7-1.9-15.3-5.5z"
      />
      <path
        id="HasOffers_svg__XMLID_4_"
        className="HasOffers_svg__st0"
        d="M372.9 135.3c0-5.2-4.3-9.5-9.5-9.5s-9.5 4.3-9.5 9.5v12.3c0 .3.3.6.6.6h3.3c.3 0 .6-.3.6-.6v-12.3c0-2.8 2.2-5 5-5s5 2.2 5 5v12.3c0 .3.3.6.6.6h3.3c.3 0 .6-.3.6-.6v-12.3z"
      />
      <path
        id="HasOffers_svg__XMLID_3_"
        className="HasOffers_svg__st0"
        d="M306.8 126.4v3.3c0 .3.3.6.6.6h6c.3 0 .6.3.6.6v16.7c0 .3.3.6.6.6h3.3c.3 0 .6-.3.6-.6v-16.7c0-.3.3-.6.6-.6h6c.3 0 .6-.3.6-.6v-3.3c0-.3-.3-.6-.6-.6h-17.8c-.2 0-.5.2-.5.6z"
      />
      <path
        id="HasOffers_svg__XMLID_2_"
        className="HasOffers_svg__st0"
        d="M330.3 138.7c0 5.2 4.3 9.5 9.5 9.5s9.5-4.3 9.5-9.5v-12.3c0-.3-.3-.6-.6-.6h-3.3c-.3 0-.6.3-.6.6v12.3c0 2.8-2.2 5-5 5s-5-2.2-5-5v-12.3c0-.3-.3-.6-.6-.6h-3.3c-.3 0-.6.3-.6.6v12.3z"
      />
      <path
        id="HasOffers_svg__XMLID_1_"
        className="HasOffers_svg__st0"
        d="M386.9 130.3h8.9c.3 0 .6-.3.6-.6v-3.3c0-.3-.3-.6-.6-.6h-9c-5.2.1-9.4 4.3-9.4 9.5v3.5c0 5.2 4.2 9.4 9.4 9.5h9c.3 0 .6-.3.6-.6v-3.3c0-.3-.3-.6-.6-.6h-8.9c-2.3 0-4.3-1.6-4.8-3.8-.1-.4.2-.8.6-.8h13.2c.3 0 .6-.3.6-.6v-3.3c0-.3-.3-.6-.6-.6h-13.2c-.4 0-.7-.4-.6-.8.5-2.1 2.4-3.6 4.8-3.6z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgHasOffers);
